// @ts-nocheck

import React from 'react';
import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../../../hooks/useMergeProps';
import useOpenBoomView from '../../hooks/useOpenBoomView';
import { selectIsBoomPlayable } from '../../selectors/runtime.selector';

import BoomBanner from './BoomBanner';
import makeSelectBoomBannerPropsSelector from './BoomBanner.selector';

interface IBoomBannerContainerProps {
  className?: string;
}

const BoomBannerContainer = (ownProps: IBoomBannerContainerProps) => {
  const selector = useMemo(() => makeSelectBoomBannerPropsSelector(), []);
  const selectedProps = useSelector(selector);
  const isBoomPlayable = useSelector(selectIsBoomPlayable);
  const openBoomView = useOpenBoomView();

  const onClick = useCallback(
    (e) => {
      if (e) {
        e.stopPropagation();
      }

      openBoomView();
    },
    [openBoomView],
  );

  const otherProps = useMemo(
    () => ({
      onClick,
    }),
    [onClick],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return isBoomPlayable ? <BoomBanner {...enhancedProps} /> : null;
};

export default BoomBannerContainer;
